<template>
  <h2 class="pb-2 border-bottom">Serviços Gerais de Atenção Primária</h2>
  <h3>Cuidados Primários / Pediatria</h3>
  <ul>
    <li>Check-ups de rotina e cuidados preventivos — consultas regulares para se antecipar a problemas de saúde.</li>
    <li>Exames físicos anuais — avaliações completas para acompanhar sua saúde geral.</li>
    <li>Consultas de bem-estar — planos personalizados para apoiar um estilo de vida mais saudável.</li>
    <li>Vacinas e imunizações — proteção para crianças e adultos em todas as fases da vida.</li>
    <li>Exames escolares — avaliações obrigatórias para manter as crianças seguras e prontas para a escola.</li>
  </ul>

  <h3>Gerenciamento de Condições Crônicas</h3>
  <ul>
    <li>Controle do diabetes — acompanhamento contínuo e tratamento para manter a glicose sob controle.</li>
    <li>Controle da hipertensão — cuidado personalizado para gerenciar a pressão arterial de forma eficaz.</li>
    <li>Distúrbios da tireoide — diagnóstico e tratamento do hipotireoidismo, hipertireoidismo e condições relacionadas.</li>
    <li>Colesterol alto — planos para reduzir o risco cardiovascular e melhorar o bem-estar.</li>
    <li>Obesidade & controle de peso — programas seguros e supervisionados para alcançar e manter um peso saudável.</li>
  </ul>

  <h3>Cuidados Médicos Gerais</h3>
  <ul>
    <li>Exames de triagem (pressão arterial, colesterol, diabetes, etc.) — a detecção precoce salva vidas.</li>
    <li>Atendimento agudo & consultas por doença — alívio rápido para resfriados, gripes, infecções e outros problemas.</li>
    <li>Tratamento de pequenas lesões & feridas — cuidado rápido e seguro para acidentes do dia a dia.</li>
    <li>Cuidados com alergias & asma — diagnóstico e manejo para alívio duradouro.</li>
    <li>Cefaleias & enxaquecas — avaliação e tratamento para melhorar a qualidade de vida.</li>
  </ul>

  <h3>Saúde da Mulher</h3>
  <ul>
    <li>Exames ginecológicos — cuidados preventivos e de rotina para todas as fases da vida.</li>
    <li>Orientação sobre contracepção — escolhas seguras e informadas, adaptadas às suas necessidades.</li>
    <li>Manejo da menopausa — alívio dos sintomas e melhora do conforto.</li>
    <li>Tratamento para SOP & tireoide — planos completos para equilíbrio hormonal.</li>
  </ul>

  <h3>Saúde do Homem</h3>
  <ul>
    <li>Programas de saúde masculina — cuidados preventivos e especializados para pacientes do sexo masculino.</li>
    <li>Exames de próstata — detecção precoce para maior tranquilidade.</li>
    <li>Tratamento da disfunção erétil — soluções médicas seguras e discretas.</li>
    <li>Terapia de reposição de testosterona (TRT) — acompanhamento supervisionado para restaurar vitalidade.</li>
  </ul>

  <h3>Terapias Hormonais & Especializadas</h3>
  <ul>
    <li>Terapia de reposição hormonal (HRT) — programas personalizados para energia, equilíbrio e bem-estar.</li>
    <li>Programas médicos de emagrecimento — abordagens seguras e estruturadas, com supervisão profissional.</li>
    <li>Medicamentos para perda de peso — prescritos quando apropriado, para apoiar o controle do peso.</li>
    <li>Saúde metabólica & emagrecimento — estratégias para melhorar o metabolismo e garantir resultados duradouros.</li>
  </ul>

  <h3>Saúde Mental & Comportamental</h3>
  <ul>
    <li>Atenção em saúde mental e comportamental — suporte holístico para o bem-estar emocional.</li>
    <li>Manejo de ansiedade & depressão — tratamentos baseados em evidências para estabilidade e alívio.</li>
    <li>Avaliação & tratamento de TDAH — diagnóstico preciso e planos de apoio personalizados.</li>
    <li>Tratamento de distúrbios do sono — soluções para melhorar o descanso e o desempenho diário.</li>
  </ul>

  <h3>Procedimentos Menores</h3>
  <ul>
    <li>Reparo de lóbulo da orelha — restauração da forma após danos ou alongamento.</li>
    <li>Remoção de cistos — procedimento cirúrgico simples e seguro realizado em consultório.</li>
  </ul>

  <h3>Serviços Adicionais que Oferecemos</h3>
  <ul>
    <li>Consultas por telemedicina — atendimento virtual seguro de qualquer lugar.</li>
    <li>Terapias intravenosas (IV) & infusões de vitaminas — energia, imunidade e hidratação.</li>
    <li>Dermatologia & cuidados com a pele (acne, alergias, remoção de pintas) — pele saudável com orientação médica.</li>
    <li>Saúde sexual (testes de IST, terapia hormonal) — atendimento confidencial e profissional.</li>
    <li>Programas para parar de fumar — suporte personalizado para abandonar o vício de forma definitiva.</li>
  </ul>
  <p>“De crianças a adultos, nossa equipe bilíngue está pronta para oferecer cuidados acessíveis e personalizados em todas as fases da vida. Agende sua consulta hoje mesmo.”</p>
</template>

<script>
export default {
  name: 'ContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
